module.exports = __webpack_public_path__ + "static/gw_logo-quer-f2f468d40feb6911f3eb04e0218fda73.svg";